import React from 'react'
import { useRef, useState, useEffect } from "react";
import { Card, Row, Image, Button } from "react-bootstrap";
import Form from 'react-bootstrap/Form';
import './intentPage.css'
import { setToLS } from '../../utils/storage';
import { useNavigate } from "react-router-dom";
import CDB from "../vendorimages/CDB.png"
const Intent = (props) => {
    // Setting page url for helper function
    useEffect(() => {
        setToLS("url",  ["myapps"])
    }, [])

    let navigate = useNavigate();
    const intentOptionsCheckHolder = {
        "M&A": false,
        "Onboarding": false,
        "Client Sync": false,
        "Other": false
    }
    const handleChange = (event) => {
        intentOptionsCheckHolder[event.target.id] = event.target.checked
    }

    const handleIntentSave = () => {
        const intents = []
        for(let intent in intentOptionsCheckHolder){
            if(intentOptionsCheckHolder[intent]===true){
                intents.push(intent)
            }
        }
        setToLS("intent", intents)
        localStorage.setItem("defaultActiveKey", "recommendation")
        // setTimeout(() => {
            navigate('/dashboard')
        // }, 3000);
    }
    const handleIntentSkip = () => {
        setToLS("intent", [])
        navigate('/dashboard')
    }

    return(
        <Row className="card-container-noaccess">
        <Card className="intent">
            <span className="intent-header"> 
            <Image className="intent-image" src={CDB}/>
            Cygnus Accounting Hub Dashboard&nbsp; &nbsp;</span>
            <Card.Body className="intent-message">
                What is your intent of using CAH dashboard?

                <div className='checkbox-container'>
                <Form>
                        <div key={"default-checkbox"} className="mb-3">
                        <Form.Check // prettier-ignore
                            type={"checkbox"}
                            id={"M&A"}
                            label={"Merger and Acquisition"}
                            className="intent-check"
                            onChange={(e)=>handleChange(e)}
                        />

                        <Form.Check
                            type={"checkbox"}
                            id={"Onboarding"}
                            label={"Onboarding"}
                            className="intent-check"
                            onChange={(e)=>handleChange(e)}
                        />

                        <Form.Check
                            type={"checkbox"}
                            id={"Client Sync"}
                            label={"Client Sync"}
                            className="intent-check"
                            onChange={(e)=>handleChange(e)}
                        />

                        <Form.Check
                            type={"checkbox"}
                            id={"default-checkbox-3"}
                            label={"Other"}
                            className="intent-check"
                            onChange={(e)=>handleChange(e)}
                        />
                        </div>
                    </Form>
                </div>
                <span className='intent-instruction'><p>Please select the intent of using CAH Dashboard, based on your intent of use and selected vendors we will provide personalized recommendations of flows.</p></span>
            </Card.Body>
           <div className="intent-buttons">
            <Button className="intent-save" onClick={()=>handleIntentSave()}> Save</Button>
            <Button className="intent-skip" onClick={()=>handleIntentSkip()}> Skip </Button>
           </div>
        </Card>
    </Row>
        )
}

export default Intent
